import React, { useState, useEffect, useMemo } from 'react';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import classNames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { IDesignerProfile } from '@components/pages/DesignerProfile/graphql/designer-profile-query.graphql';
import styles from './Video.module.scss';

declare const window: any;

export interface IDesignerVideoProps {
  className?: string;
  designer: IDesignerProfile;
}

const DesignerVideo = ({
  className = '',
  designer,
}: IDesignerVideoProps) => {
  const {
    id: designerId, firstName, lastName, youtubeId
  } = designer;
  const [hasStartedVideo, setHasStartedVideo] = useState(false);
  const videoId = useMemo(uuidv4, []);

  const onPlayerStateChange = (e: any) => {
    if (e.data === window?.YT.PlayerState.PLAYING && !hasStartedVideo) {
      analyticsTrack('designer_info', {
        action: 'watch',
        designer_name: `${firstName} ${lastName}`,
        designer_id: designerId
      });
      return setHasStartedVideo(true);
    }
    return false;
  };

  const initializePlayer = () => {
    if (youtubeId) {
      // eslint-disable-next-line no-new
      new window.YT.Player(videoId, {
        videoId: youtubeId,
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    }
  };

  useEffect(() => {
    if (window) {
      if (window.YT === undefined) window.onYouTubeIframeAPIReady = initializePlayer;
      else window.YT.ready(initializePlayer);

      return () => {
        window.onYouTubeIframeAPIReady = () => false;
      };
    } else {
      return () => { };
    }
  }, []);

  return (
    <div className={classNames(styles.Root, className)}>
      <div className={styles.VideoFrame} id={videoId} data-test="video" />
    </div>
  );
};

export default DesignerVideo;
